import { css } from 'styled-components';
const lato = {
    light: { family: 'Lato', weight: 300 },
    base: {
        family: 'Lato',
        weight: 400,
    },
    semiBold: {
        family: 'Lato',
        weight: 500,
    },
    medium: {
        family: 'Lato',
        weight: 600,
    },
    bold: {
        family: 'Lato',
        weight: 700,
    },
    black: {
        family: 'Lato',
        weight: 900,
    },
};
const swis721 = {
    black: {
        family: 'Swis721',
        weight: 900,
    },
};
const christmas = {
    base: {
        family: 'Certhas',
        weight: 400,
    },
};
const wreath = {
    base: {
        family: 'Wreath Halftone',
        weight: 400,
    },
};
export default {
    lato: {
        light: () => css `
      font-family: ${lato.light.family};
      font-weight: ${lato.light.weight};
    `,
        base: () => css `
      font-family: ${lato.base.family};
      font-weight: ${lato.base.weight};
    `,
        semiBold: () => css `
      font-family: ${lato.semiBold.family};
      font-weight: ${lato.semiBold.weight};
    `,
        medium: () => css `
      font-family: ${lato.medium.family};
      font-weight: ${lato.medium.weight};
    `,
        bold: () => css `
      font-family: ${lato.bold.family};
      font-weight: ${lato.bold.weight};
    `,
        black: () => css `
      font-family: ${lato.black.family};
      font-weight: ${lato.black.weight};
    `,
    },
    swis721: {
        black: () => css `
      font-family: ${swis721.black.family};
      font-weight: ${swis721.black.weight};
    `,
    },
    christmas: {
        base: () => css `
      font-family: ${christmas.base.family};
      font-weight: ${christmas.base.weight};
    `,
    },
    wreath: {
        base: () => css `
      font-family: ${wreath.base.family};
      font-weight: ${wreath.base.weight};
    `,
    },
    ls: (value) => {
        return `calc(${value / 1000} * 1em)`;
    },
};
